import i18n from "@/i18n";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";
import { AdminRoutes } from "@/data/enums/router";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: event => [
        {
          slot: "email",
          message: event?.object?.email,
          is: "u-link",
          props: {
            tag: "router-link",
            to: {
              name: AdminRoutes.CLIENT_SETTINGS_PROFILE,
              params: {
                clientId: event?.object?.client_id
              }
            }
          },
          class: "has-text-dark has-text-underline"
        }
      ]
    })
  }
});

export default {
  ...createEventMap(HookCodes.CLIENT_EMAIL_UPDATED),
  ...createEventMap(HookCodes.CLIENT_EMAIL_VERIFIED),
  ...createEventMap(HookCodes.CLIENT_EMAIL_DELETED, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.CLIENT_EMAIL_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.CLIENT_EMAIL_VERIFICATION_REQUIRED)
};
